import { ModalPopup, TextArea } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import contentConstants from '../../contentConstants';
import { ISurveyNote } from '../../models';

export interface ISurveyNoteModalProps {
	isOpen: boolean;
	surveyNote?: ISurveyNote;
	saveSurveyNote: (noteText: string) => void;
	deleteSurveyNote: () => void;
	toggleModal: () => void;
}
export interface ISurveyNoteModalState {
	noteText: string;
}

export const Content = styled.div`
	width: 100%;
`;

export const NoteTextArea = styled(TextArea)`
	min-width: 100%;
	min-height: 350px;
	max-height: 350px;
`;

export class SurveyNoteModal extends React.Component<ISurveyNoteModalProps, ISurveyNoteModalState> {
	constructor(props: ISurveyNoteModalProps) {
		super(props);

		this.state = {
			noteText: this.props.surveyNote ? this.props.surveyNote.text : '',
		};

		this.saveSurveyNote = this.saveSurveyNote.bind(this);
		this.deleteSurveyNote = this.deleteSurveyNote.bind(this);
		this.updateText = this.updateText.bind(this);
	}

	public UNSAFE_componentWillReceiveProps(props: ISurveyNoteModalProps) {
		this.setState({ noteText: props.surveyNote ? props.surveyNote.text : '' });
	}

	public render() {
		const { isOpen, toggleModal, surveyNote } = this.props;
		const { noteText } = this.state;

		return (
			<ModalPopup
				isOpen={isOpen}
				title={contentConstants.SURVEY_NOTE}
				onAlternatePrimaryButtonClick={surveyNote ? this.deleteSurveyNote : undefined}
				onClosed={toggleModal}
				onSubmit={this.saveSurveyNote}
				primaryButtonText={contentConstants.BUTTONS_SAVE}
				alternatePrimaryButtonText={contentConstants.BUTTONS_DELETE_NOTE}
				secondaryButtonText={contentConstants.BUTTONS_CANCEL}
				contentfullwidth={false}
				contenthcentered={true}
			>
				<Content>
					<NoteTextArea placeholder={contentConstants.SURVEY_NOTE_PLACEHOLDER} value={noteText} onChange={this.updateText} />
				</Content>
			</ModalPopup>
		);
	}

	public updateText(event: any) {
		this.setState({ noteText: event.target.value });
	}

	public saveSurveyNote() {
		this.props.saveSurveyNote(this.state.noteText);
		this.props.toggleModal();
	}

	public deleteSurveyNote() {
		this.props.deleteSurveyNote();
		this.props.toggleModal();
	}
}
